import { Play } from "lucide-react";

const SHOW_IMAGES = [
  {
    url: "/images/story-toronto-1.jpg",
    caption: "STORY — Toronto",
  },
  {
    url: "/images/show-liveset.jpg",
    caption: "CODA — Toronto",
  },
  {
    url: "/images/show-behind-decks.jpg",
    caption: "HISTORY — Toronto",
  },
];

const PERFORMANCE_VIDEO = "/images/performance-video.mp4";
const VIDEO_POSTER = "/images/show-behind-decks.jpg";

export const VisualsSection = () => {
  return (
    <section data-testid="visuals-section" className="py-24 md:py-32 tracing-border">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="mb-16">
          <p className="font-sub text-[10px] text-white/30 tracking-[0.3em] mb-4">002</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tighter">VISUALS</h2>
          <div className="gold-line mt-6" />
        </div>

        {/* Performance Video */}
        <div
          data-testid="video-section"
          className="relative w-full mb-16 overflow-hidden border border-white/10"
        >
          <video
            data-testid="performance-video"
            controls
            poster={VIDEO_POSTER}
            className="w-full aspect-video bg-black"
            preload="metadata"
          >
            <source src={PERFORMANCE_VIDEO} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#050505]/80 to-transparent h-16 pointer-events-none" />
        </div>

        {/* Show Gallery */}
        <div className="mb-8">
          <p className="font-sub text-[10px] text-white/30 tracking-[0.3em] mb-8">SHOW GALLERY</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {SHOW_IMAGES.map((img, i) => (
            <div
              key={img.url}
              data-testid={`gallery-image-${i}`}
              className="relative aspect-[4/3] overflow-hidden border border-white/5 group"
            >
              <img
                src={img.url}
                alt={img.caption}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-[#050505]/40 group-hover:bg-[#050505]/20 transition-colors duration-300" />
              <div className="absolute bottom-4 left-4">
                <p className="font-sub text-[10px] text-white/60 tracking-widest">{img.caption}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
